/* Use this file to track component suffixes */

export const threeLiteralSuffixes = ['a', 'b', 'c']
export const fourLiteralSuffixes = ['a', 'b', 'c', 'd']
export const defy5hzHeroSuffixes = ['b', 'c', 'd', 'e', 'f', 'g']
